export function calcHeight() {
  const checkIOS = () => {
    if (navigator.standalone !== undefined) {
      return 'breakFunction';
    }
    return 'continueFunction';
  };

  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  window.addEventListener('resize', () => {
    const isIos = checkIOS();
    if (isIos === 'breakFunction') return;
    setFillHeight();
  });

  setFillHeight();
}
